module.exports = __webpack_public_path__ + "img/Visio Logo.43caf85c.png";